import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[100]}`
  },
  titleContainer: {
    height: 50,
    textAlign: 'center',
    fontWeight: 700,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  valueContainer: {
    height: 50,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  currencySelectorContainer: {
    position: 'absolute',
    right: '1%',
    top: 2
  },
  input: {
    border: 'none',
    outline: 'none',
    width: '80%',
    fontSize: 16,
    lineHeight: '46px',
    marginLeft: '4%'
  },
  deleteIconContainer: {
    position: 'absolute',
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 8,
    right: 8
  },
  deleteIcon: {
    fontSize: 16
  }
}))

export default useStyles
